<template>
  <!--
    eval / emergency / warning は UI に表示しない (旧 Q4CL-client と同仕様)。
    これらは送信時の計算用途専用で、結果は info.alert や送信 payload に反映される。
    将来的に表示したくなったら、問診票定義側に `visible: true` 等のオプトインフラグを
    入れる形で復活させるのが安全 (デフォルト非表示)。
  -->
  <span class="hidden"></span>
</template>

<script>
export default {
  name: 'EvalField',
  props: { field: { type: Object, required: true } }
};
</script>
